import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { get } from "../../../utils/fetch";
import { useSemaforoSeguimiento } from "../../../hooks/useAsistenciasSemaforo";

export const useGetSeguimiento = () => {
  const { asistencias, loading, error } = useSemaforoSeguimiento();
  return { servicios: asistencias, loading, error };
};

export const useFetchList = (url) => {
  const [listado, setListado] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const result = await get(url);
      setListado(result.data || []);
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { listado, loading, refetch: fetch };
};

export const useFormPost = (postAction, buildBody, onSuccess) => {
  const dispatch = useDispatch();
  const [fields, setFields] = useState({});
  const [sending, setSending] = useState(false);

  const setField = useCallback((name, value) => {
    setFields((prev) => ({ ...prev, [name]: value }));
  }, []);

  const submit = useCallback(async () => {
    if (sending) return;
    const body = buildBody(fields);
    setSending(true);
    try {
      await dispatch(postAction(body));
      setFields({});
      onSuccess?.();
    } finally {
      setSending(false);
    }
  }, [dispatch, fields, postAction, buildBody, onSuccess, sending]);

  return { fields, setField, submit, sending };
};
